<template>
  <div class="auth" id="auth" name="auth">
    <div class="top">
      <NavTop activeIndex="3"></NavTop>
    </div>
    <div class="content-box">
      <div v-html="tetx"></div>
    </div>
  </div>
</template>
<script>
import NavTop from '../components/NavTopWhit.vue'
import { getConfig } from '../api/user'
export default {
  components: {
    NavTop
  },
  data() {
    return {
      name: '',
      pass: '',
      buttonText: '获取验证码',
      tetx: ""
    }
  },
  created() {
    this.getINfo()

  },
  methods: {
  
    getINfo() {
      getConfig().then(res => {
        this.tetx = res.data.tutorial
      })
    }
  }
}
</script>
<style scoped>
.content-box {
  width: 1200px;
  background-color: #fff;
  margin: 140px auto;
  padding: 40px;
  box-sizing: border-box;

}

.el-form {
  width: 300px;
  margin: 80px auto;
}
</style>